import React from "react";
import Link from "@material-ui/core/Link";
import Box from '@material-ui/core/Box';
import { useStyles } from './style';
import uuid from 'react-uuid';

export default function LinkComp(props) {
    const { data, showHyperlink, icon, component } = props;
    const classes = useStyles();
    return (
        <>
            <Box component="div" display='inline' className={classes.root}>
                <img src={icon} style={{ width: '16px', height: '16px' }} alt={'icon'} />
                <Box component="div" display='inline' className={classes.metaLinks}>
                    {data && data.length > 0 ? data.map(linkDetail => {
                        
                        return (
                            
                            <Link
                                key={uuid()}
                                target="_blank"
                                variant="body2"
                                underline={showHyperlink ? 'always' : 'none'}
                                href={linkDetail.url ? linkDetail.url : linkDetail}
                                className={!showHyperlink ? classes.custom : classes.hyperlink}
                            >
                                {component === 'resources'    ? linkDetail && linkDetail.name : linkDetail}

                            </Link>
                        )
                    }) :
                        <Link key={uuid()} target="_blank" variant="body2" className={classes.custom}> NA </Link>
                    }
                </Box>
            </Box>
        </>
    );
}
